module.exports = __webpack_public_path__ + "img/menu14.c81f5ebc.png";